class CartMain extends Component {
    constructor(el) {
        super(el);
        this.form = this.$el.closest('form');
        this.debounceInterval = undefined;
        this.addEventListeners();
    }

    reRenderCart(data, cartBarData = null) {
        const htmlData = new DOMParser().parseFromString(data, 'text/html');
        const componentSource = htmlData.querySelector('[data-step-cart]');
        const dataStepCart = this.$el.querySelector('[data-step-cart]');
        if (!componentSource || !dataStepCart) {
            throw new Error("Nepodařilo se aktualizovat košík, nebyl nalezen požadovaný container!");
        }
        dataStepCart.innerHTML = componentSource.innerHTML;
        if (cartBarData) {
            const cartBarSource = new DOMParser().parseFromString(cartBarData, 'text/html').querySelector('.CartBar');
            const cartBar = this.$el.closest('.CartLayout')?.querySelector('.CartBar');
            if (cartBarSource && cartBar) {
                cartBar.replaceWith(cartBarSource);
            }
        }

        Component.initComponents();
    }

    /**
     * @param {OrderUpdateStepCartData|{}} params
     */
    updateCart(params) {
        let formData = new FormData(this.form);
        let action = params.href === undefined ? window.location.pathname : params.href;
        EventBus.getInstance().dispatchEvent('showGlobalSpinner');
        formData.append('ajax-cart', '1');
        if (params.recalculate !== undefined) {
            formData.set("recalculate", params.recalculate ? 1 : 0);
        }

        fetch(action, {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(data => this.onCartUpdated(data))
        .finally(() => EventBus.getInstance().dispatchEvent('hideGlobalSpinner'));
    }

    onCartUpdated(data) {
        this.reRenderCart(data.views['Cart'], data.views['cartBar']);
        if (data.remarketingCodes) {
            Util.appendToBody(data.remarketingCodes);
        }
    }

    addEventListeners() {
        EventBus.getInstance().addEventListener('orderUpdateStepCart', e => {
            this.debounceInterval && clearTimeout(this.debounceInterval);
            this.debounceInterval = setTimeout(() => this.updateCart(e.detail), 300);
        });
    }
}
